// extracted by mini-css-extract-plugin
export default {"listWithCheck":"listItemWithCheckMark_listWithCheck__guh4d","text":"listItemWithCheckMark_text__flKq4"};